"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("./utils");

var experimentUniqueIdGroup = function experimentUniqueIdGroup(_ref) {
  var experimentName = _ref.experimentName,
      uid = _ref.uid,
      groups = _ref.groups,
      logger = _ref.logger;

  if (groups === 0) {
    return null;
  }

  var hash = (0, _utils.createHash)(uid + experimentName);
  var group = hash % groups;

  if (logger && typeof logger === 'function') {
    logger(group);
  }

  return group;
};

var _default = experimentUniqueIdGroup;
exports["default"] = _default;